var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lee-timeline"},[(_vm.limitnum!=0&&_vm.limitnum<_vm.totalnum)?_c('div',{staticClass:"mark"}):_vm._e(),_vm._v(" "),_c('ul',[_vm._t("default")],2),_vm._v(" "),(_vm.limitnum!=0&&_vm.limitnum<_vm.totalnum)?_c('div',{staticClass:"more",on:{"click":_vm.chuli}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-449d9ee9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/leevueplugin/src/LeeTimeline.vue
// module id = Teox
// module chunks = 170